import { render, staticRenderFns } from "./MAdminList.vue?vue&type=template&id=79e5ab5a&scoped=true&"
import script from "./MAdminList.vue?vue&type=script&lang=ts&"
export * from "./MAdminList.vue?vue&type=script&lang=ts&"
import style0 from "./MAdminList.vue?vue&type=style&index=0&id=79e5ab5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e5ab5a",
  null
  
)

export default component.exports